import { useState, useContext } from "react";
import primaryComponents from "../../primaryComponents";
import Validation from "./Validation";
import { useSelector } from "react-redux";
// import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { useCreateCustomerMutation } from "../../../hooks/api/mutations/useCustomer";
import { ToastContext } from "../../../hooks/context";
import { useParams } from "react-router-dom";
// import { useGetInfo } from "../../../hooks/useGetInfo";

const AddCustomer = ({ closeModal = () => {}, addCustomer }) => {
  const { business_phone_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { store_id } = useParams();
  // const { getStoreInfo } = useGetInfo();
  // const storeDetails = getStoreInfo(store_id);
  const triggerToast = useContext(ToastContext);
  const [customerDetails, setCustomerDetails] = useState({
    first_name: "",
    last_name: "",
    customerEmail: "",
    customerPhoneNumber: "",
    customerPhoneCode: business_phone_code,
    is_loyalty_eligible: false,
    store_id: store_id,
    gender: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    trigger,
  } = Validation({ customerDetails });

  const createCustomerMutation = useCreateCustomerMutation();
  const handleAddCustomer = () => {
    const data = {
      first_name: customerDetails?.first_name,
      last_name: customerDetails?.last_name,
      email: customerDetails?.customerEmail,
      phone_code: customerDetails?.customerPhoneCode,
      phone_number: customerDetails?.customerPhoneNumber,
      store_id: customerDetails?.store_id,
      gender: customerDetails?.gender,
    };
    createCustomerMutation.mutate(data, {
      onSuccess: (res) => {
        const data = res?.data?.data;
        triggerToast("Customer added successfully", "success");
        addCustomer({
          customerId: data?.id,
          customer_id: data?.id,
          customer_phone_number: customerDetails?.customerPhoneNumber,
          customer_full_name:
            !data?.full_name || data?.full_name === "N/A"
              ? `${data?.first_name || ""}`.trim()
              : data?.full_name,
          customer_email: customerDetails?.customerEmail,
          customer_phone_code: customerDetails?.customerPhoneCode,
          credit_limit: data?.credit_limit,
          outstanding_balance: data?.outstanding_balance,
        });
        closeModal();
      },
    });
  };

  return (
    <form className="px-2 py-2 d-flex flex-column" style={{ gap: "10px" }}>
      <h4 className="text-center">Add new customer</h4>
      <div className="d-flex" style={{ gap: "5px" }}>
        <primaryComponents.InputFieldV2
          isRequired
          control={control}
          label="Customer First Name"
          placeholder="Enter Customer First Name"
          name="customerName"
          errorMessage={errors.customerName}
          value={customerDetails?.first_name}
          onKeyUp={() =>
            errors.customerName !== undefined && trigger("customerName")
          }
          onChange={({ target: { value } }) => {
            setCustomerDetails((prev) => ({ ...prev, first_name: value }));
          }}
          register={register}
        />

        <primaryComponents.InputFieldV2
          isRequired
          control={control}
          label="Customer Last Name"
          name="customerLastName"
          placeholder="Enter Customer Last Name"
          value={customerDetails?.last_name}
          errorMessage={errors.customerLastName}
          onKeyUp={() =>
            errors.customerLastName !== undefined && trigger("customerLastName")
          }
          onChange={({ target: { value } }) => {
            setCustomerDetails((prev) => ({ ...prev, last_name: value }));
          }}
          register={register}
        />
      </div>

      <primaryComponents.PhoneNumberInputFieldV2
        control={control}
        label="Customer Phone Number"
        placeholder="Enter Customer's Phone Number"
        name="customerPhoneNumber"
        value={customerDetails?.customerPhoneNumber}
        errorMessage={errors?.customerPhoneNumber}
        onKeyUp={() =>
          errors.customerPhoneNumber !== undefined &&
          trigger("customerPhoneNumber")
        }
        onChange={({ target: { value } }) => {
          setCustomerDetails((prev) => ({
            ...prev,
            customerPhoneNumber: value,
          }));
        }}
        isRequired
        register={register}
        phoneCodeEditable={true}
        onChangePhoneCode={(val) =>
          setCustomerDetails((prev) => ({
            ...prev,
            customerPhoneCode: val,
          }))
        }
      />

      <primaryComponents.InputFieldV2
        control={control}
        label="Customer Email"
        placeholder="Enter Customer Email"
        name="customerEmail"
        // isRequired={storeDetails?.required_customer_details?.length > 0}
        errorMessage={errors.customerEmail}
        value={customerDetails?.customerEmail}
        onKeyUp={() =>
          errors.customerEmail !== undefined && trigger("customerEmail")
        }
        onChange={({ target: { value } }) => {
          setCustomerDetails((prev) => ({ ...prev, customerEmail: value }));
        }}
        register={register}
      />

      <div
        className="d-flex align-items-center w-100 mb-3"
        style={{ gap: "20px" }}
      >
        <primaryComponents.RadioButton
          name={"customerGender"}
          id="MALE"
          checked={customerDetails.gender === "MALE"}
          setRadioValue={() =>
            setCustomerDetails((prev) => ({ ...prev, gender: "MALE" }))
          }
        >
          Male
        </primaryComponents.RadioButton>
        <primaryComponents.RadioButton
          name={"customerGender"}
          id="FEMALE"
          checked={customerDetails.gender === "FEMALE"}
          setRadioValue={() =>
            setCustomerDetails((prev) => ({ ...prev, gender: "FEMALE" }))
          }
        >
          Female
        </primaryComponents.RadioButton>
      </div>

      {/* <div className={`${globalStyles.cardWithBorder} mt-2 mb-3`}>
        <div className="d-flex justify-content-between">
          <div>
            <p className="mb-0 small-text-size">
              Enable or Disable Loyalty for this customer
            </p>
          </div>
          <primaryComponents.Switch
            name={"loyalty"}
            id={customerDetails}
            isChecked={isLoyaltyEligible}
            onChange={(value) => {
              setCustomerDetails((prev) => ({
                ...prev,
                is_loyalty_eligible: value,
              }));
            }}
          />
        </div>
      </div> */}

      <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          onClick={closeModal}
        >
          Cancel
        </primaryComponents.Button>
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          type="submit"
          isDisabled={createCustomerMutation?.isLoading}
          isLoading={createCustomerMutation?.isLoading}
          loadingText={"Adding customer..."}
          onClick={handleSubmit(handleAddCustomer)}
        >
          Add customer
        </primaryComponents.Button>
      </div>
    </form>
  );
};
export default AddCustomer;
